import { SeoServiceService } from "./../../services/seo-service.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  liveIsActive: boolean = true;

  constructor(private seoService: SeoServiceService) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
  }
}
